/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetConnectWifiIcon24Regular = forwardRef('NetConnectWifiIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 5.75a12.75 12.75 0 0 0-9.502 4.248.75.75 0 1 1-1.118-1A14.25 14.25 0 0 1 22.62 9a.75.75 0 0 1-1.117 1A12.75 12.75 0 0 0 12 5.75Z" }),
        React.createElement("path", { d: "M14.694 12.86a6.25 6.25 0 0 0-7.561 1.72.75.75 0 0 1-1.169-.941 7.751 7.751 0 0 1 12.068-.006.75.75 0 0 1-1.168.942 6.248 6.248 0 0 0-2.17-1.714Z" }),
        React.createElement("path", { d: "M12 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" })));
});
